import { Button } from '../Button'
import { Styled } from '../../Layout/Footer/styled'
import * as React from 'react'
import { useI18n } from '../../../lib/context/i18n'
import { langLabelMap } from '../../../../config/storyblok/languages'

export const LanguageSelect = () => {
  const { currentLanguage, allLanguages, changeLanguage } = useI18n()
  const [show, setShow] = React.useState(false)

  return (
    <Styled.Language>
      <Button
        $size="small"
        $variant="tertiary"
        $ignoreTheme={true}
        iconRight={'world'}
        className={show && 'active'}
        onClick={() => {
          setShow(!show)
        }}
      >
        {langLabelMap[currentLanguage]}
      </Button>
      <Styled.LanguageDropdown show={show}>
        {allLanguages.length > 0 &&
          allLanguages.map(language => (
            <Button
              $size="small"
              $variant="tertiary"
              $ignoreTheme={true}
              onClick={() => {
                changeLanguage(language)
                setShow(false)
              }}
              key={language}
            >
              {langLabelMap[language]}
            </Button>
          ))}
      </Styled.LanguageDropdown>
    </Styled.Language>
  )
}
